import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import DashboardLayout from "../../layout/Layout";
import Input from "../../common/Input";
import Api from "../../api/api";
import Select from "../../common/Select";
import { countries } from "../../utils/countries";
import PhoneInput from "react-phone-input-2";
import Button from "../../common/Button";

const initialData = {
  fname: "",
  lname: "",
};

const Profile = () => {
  const [isDisable, setIsDisable] = useState(false);
  const [data, setData] = useState({ ...initialData });

  const handleChange = e => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!data.phone) {
      return toast.error("Phone number is required");
    }

    setIsDisable(true);
    try {
      const res = await Api.updateMyProfile(data);
      if (res.status === 200) {
        toast.success(res.data.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsDisable(false);
    }
  };

  const getMyProfile = async () => {
    try {
      const res = await Api.getMeProfile();
      if (res.status === 200) {
        const user = res.data.data;
        setData({
          fname: user?.fname,
          lname: user?.lname,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getMyProfile();

    return () => {
      setData({ ...initialData });
      setIsDisable(false);
    };
  }, []);

  return (
    <DashboardLayout title="Profile">
      <form onSubmit={handleSubmit}>
        <div className="grid gap-x-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mb-4">
          <Input
            title="First Name"
            name="fname"
            value={data.fname}
            onChange={handleChange}
            placeholder="First Name"
            disable={isDisable}
            required
          />
          <Input
            title="Last Name"
            name="lname"
            value={data.lname}
            onChange={handleChange}
            placeholder="Last Name"
            disabled={isDisable}
            required
          />
        </div>
        <Button
          type="submit"
          disabled={isDisable}
        >
          Update
        </Button>
      </form>
    </DashboardLayout>
  );
};

export default Profile;
